import {
  Scene,
  HDRCubeTexture,
  AssetsManager,
  HDRCubeTextureAssetTask,
} from 'babylonjs'

export const loadHdrTexture = (src: string, scene: Scene): HDRCubeTexture =>
  new HDRCubeTexture(src, scene, 512, false, true, false, true)

export const loadHdrTextureAssetTask = (
  src: string,
  assetsManager: AssetsManager
): HDRCubeTextureAssetTask => {
  const textureTask = assetsManager.addHDRCubeTextureTask(
    'skyboxTask',
    src,
    512
  )

  // textureTask.runTask(scene, () => {console.log('task success')}, () => {})

  // console.log('created task')

  // textureTask.onSuccess = function (task: HDRCubeTextureAssetTask) {
  //   console.log('task success')
  // }

  // textureTask.onError = function (task, message, exception) {
  //   console.log('task error', message, exception)
  // }

  // assetsManager.loadAsync()

  return textureTask
}
